export default __webpack_public_path__ + "static/media/avatar-mp-1-3.dad30fa7.png";